export default __webpack_public_path__ + "static/media/jap-ecommerceImg_1.cd8e44a5.png";